import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { useStore } from '@/stores/store-provider';
import { ChatHelp } from '@styled-icons/fluentui-system-regular/ChatHelp';
// import { Question } from '@styled-icons/octicons/Question';

const SupportIconWrapper = styled.div`
  align-items: center;
  border-radius: .5em;
  color: ${props => props.theme.colors.typography.primary};
  cursor: pointer;
  display: inline-flex;
  padding: .75em;
  position: relative;

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};

    .home & {
      background: rgba(0, 0, 0, .125);
    }
  }

  svg {
    color: ${props => props.theme.colors.typography.primary};
  }
`;

const HelpIcon = styled(ChatHelp)``;


const SupportButton = () => {
  const { supportBeaconLoaded } = useStore();
  if(!supportBeaconLoaded) {
    return null;
  }

  const toggleSupport = () => {
    window.Beacon('toggle');
  };

  return (
    <SupportIconWrapper onClick={toggleSupport}>
      <HelpIcon size={24} />
    </SupportIconWrapper>
  );
};

export default observer(SupportButton);
